"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useToastPortal = require("./useToastPortal");
Object.keys(_useToastPortal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useToastPortal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useToastPortal[key];
    }
  });
});